<template>
  <div lang="tr" class="vertical-align-step-0">
    <h3 class="main_question text-center font-weight-normal">
      {{ $t('Hangi şirket türünü seçmeliyim?') }}
      <a
        id="howToChoose"
        :href="
          $i18n.locale === 'tr'
            ? 'https://blog.mukellef.co/amerikada-yaygin-sirket-turleri-nelerdir/'
            : 'https://blog.mukellef.co/en/what-are-the-most-common-types-of-companies-in-the-usa/'
        "
        target="_blank"
        class="btn-outline-mukellef btn-radius mx-2 mt-2"
      >
        <span>{{ $t("Mükellef Blog'da Okuyun") }}</span>
      </a>
    </h3>
    <form method="POST" id="step0" @submit.prevent="sendForm" class="mb-4">
      <div
        @click="[(selectedCompanyType = product), getEntityTypes(product.code)]"
        v-for="product in types"
        class="d-flex justify-content-between box-border gap-field"
        :key="product.id"
        v-bind:class="{
          'selected-product': selectedCompanyType.code === product.code,
        }"
      >
        <div class="vertical-center ml-1">
          <div>
            <h6 class="mb-1 font-weight-bold">{{ product.name }}</h6>
          </div>
          <div>
            <ul class="vertical-center features">
              <li class="mb-1">{{ $t('Aynı gün elektronik başvuru') }}</li>
              <li class="mb-1">{{ $t('Eyalet nezdindeki tüm ücretler') }}</li>
              <li class="mb-1">{{ $t('Kuruluş Belgelerinin dijital kopyalarının gönderilmesi') }}</li>
            </ul>
          </div>
        </div>
        <div class="text-center vertical-center product-image">
          <img v-if="product.code === 'CCORP'" src="/img/company-types/anonim.svg" class="company-type-big" />
          <img v-if="product.code === 'LLC'" src="/img/company-types/limited.svg" class="company-type-medium2" />
        </div>
      </div>
      <div v-if="selectedCompanyType.has_title">
        <h3 class="main_question mt-4">{{ $t('Şirket İsmi') }}</h3>
        <div class="row">
          <div class="col-6">
            <InputField
              v-model="title"
              name="company_title"
              :placeholder="$t('Şirket İsmi')"
              v-validate="'required|min:3'"
              v-tippy="$t('Şirketinizin ismini giriniz')"
              :error="errors.first('company_title')"
              :validateFields="fields['company_title']"
            />
          </div>
          <div class="col-6">
            <v-select
              id="entity_name"
              name="entity_name"
              placeholder="Entity Ending"
              v-model="company.entity_name"
              v-validate="'required'"
              class="wide"
              :class="{ 'is-invalid': errors.first('entity_name') }"
              :options="entityTypes"
            />
            <span v-show="errors.first('entity_name')" class="show-invalid invalid-feedback">{{
              errors.first('entity_name')
            }}</span>
            <error-box field="entity_name" />
          </div>
        </div>
        <div class="form-group">
          <h3 class="main_question">{{ $t('Faaliyet Alanı') }}</h3>
          <div class="row">
            <div class="form-group col-12 mb-0">
              <div class="clearfix">
                <v-select
                  :placeholder="this.$t('Faaliyet Alanı Seçimi')"
                  :options="activityAreaOptions"
                  index="value"
                  label="label"
                  v-model="selected_activity_areas_mock"
                  :clearable="false"
                  class="wide"
                  :class="{ 'is-invalid': errors.first('global_activity_area') }"
                  v-validate="selected_activity_areas.length <= 0 ? 'required' : ''"
                  name="global_activity_area"
                  :disabled="selected_activity_areas.length >= 3"
                  @change="addToSelectedActivityAreas"
                >
                </v-select>
                <span v-show="errors.first('global_activity_area')" class="show-invalid invalid-feedback">{{
                  errors.first('global_activity_area')
                }}</span>
                <error-box field="global_activity_area" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="selected-activity-items">
                <div class="selected-activities" v-for="(area, index) in selected_activity_areas" :key="area">
                  <span>{{ getAreaValueInLocalLang(area) }}</span>
                  <button class="btn bg-white shadow-none" @click="removeSelectedArea(index)">
                    <i class="fas fa-times fa-xs" style="color: #cb444a"></i>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="selected_activity_areas.length >= 3" class="col-12">
              <div class="d-flex align-items-center text-dark activity-area-warning">
                <i class="fa fa-info-circle alert-icon-size fa-info-circle" style="color: #f2c253"></i>
                {{ $t('Faaliyet Alanı Seçimi Uyarı Metni') }}
              </div>
            </div>
          </div>
        </div>

        <h3 class="main_question">{{ $t('Şirket Eyalet seçimi') }}</h3>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <div class="clearfix">
                <v-select
                  :placeholder="this.$t('Eyalet Secimi')"
                  :options="states"
                  v-model="selectedState"
                  :searchable="false"
                  index="key"
                  label="value"
                  class="wide"
                  :class="{ 'is-invalid': errors.first('state') }"
                  v-validate="'required'"
                  name="state"
                >
                  <template #option="{ key }">
                    {{ key !== 'Other' ? key : $t('Diğer') }}
                    <span v-if="key === 'Wyoming'" class="badge-recommended">{{ $t('Önerilen') }}</span>
                  </template>
                </v-select>
              </div>
              <span v-show="errors.first('state')" class="show-invalid invalid-feedback">{{
                errors.first('state')
              }}</span>
              <error-box field="state" />
            </div>
          </div>
          <div v-if="selectedState === 'Other'" class="col-md-6">
            <div class="form-group">
              <div class="clearfix">
                <v-select
                  :placeholder="this.$t('Eyalet Secimi')"
                  :options="otherStateOptions"
                  v-model="otherState"
                  :searchable="false"
                  index="key"
                  label="value"
                  class="wide"
                  :class="{ 'is-invalid': errors.first('other-state') }"
                  v-validate="'required'"
                  name="other-state"
                >
                </v-select>
              </div>
              <span v-show="errors.first('other-state')" class="show-invalid invalid-feedback">{{
                errors.first('other-state')
              }}</span>
              <error-box field="other-state" />
            </div>
          </div>
        </div>

        <div v-if="currentState" class="alert-mukellef-warning">
          <div v-if="typeof this.getPrice(stateFeeProduct.prices.data)" class="d-flex">
            <i class="fa fa-info-circle mr-2 alert-icon-size alert-icon-spacing"></i>
            <div>
              {{ $t('Eyalet uyarı text1', { state: currentState }) }} <br />
              <div class="alert-feature-field">
                <span
                  >{{ getMultiLangName(stateFeeProduct, stateFeeProduct.name) }}:
                  {{ formatPrice(stateFeeProduct.final_price, stateFeeProduct.currency) }}
                  {{
                    stateFeeProduct.type === 'subscription'
                      ? stateFeeProduct.period === 'annual'
                        ? ' / ' + $t('Yıl')
                        : ' / ' + $t('Ay')
                      : ' / ' + $t('Tek Sefer')
                  }}</span
                >
                <br />
                <span v-if="currentState.toUpperCase() !== 'TEKSAS'"
                  >{{ getMultiLangName(franchiseTaxProduct, franchiseTaxProduct.name) }}:
                  {{ formatPrice(franchiseTaxProduct.final_price, franchiseTaxProduct.currency) }}
                  {{
                    franchiseTaxProduct.type === 'subscription'
                      ? franchiseTaxProduct.period === 'annual'
                        ? ' / ' + $t('Yıl')
                        : ' / ' + $t('Ay')
                      : ' / ' + $t('Tek Sefer')
                  }}</span
                >
                <span v-else>{{ $t('Eyalet uyarı text3', { price: formatPrice(0, company.currency.symbol) }) }}</span>
                <br />
                <span v-if="expressProduct && expressProduct.name"
                  >{{ getMultiLangName(expressProduct, expressProduct.name) }}:
                  {{ formatPrice(expressProduct.final_price, expressProduct.currency) }}
                  {{
                    expressProduct.type === 'subscription'
                      ? expressProduct.period === 'annual'
                        ? ' / ' + $t('Yıl')
                        : ' / ' + $t('Ay')
                      : ' / ' + $t('Tek Sefer')
                  }}<br
                /></span>

                <template v-if="selectedState === 'Other'">
                  <span
                    >{{
                      $t('Eyalet uyarı text4', {
                        price: formatPrice(additionalSetupFeeProduct.final_price, additionalSetupFeeProduct.currency),
                      })
                    }}

                    {{
                      additionalSetupFeeProduct.type === 'subscription'
                        ? additionalSetupFeeProduct.period === 'annual'
                          ? ' / ' + $t('Yıl')
                          : ' / ' + $t('Ay')
                        : ' / ' + $t('Tek Sefer')
                    }}
                  </span>
                </template>
                <span>
                  <ul class="warning-list-field">
                    <li v-if="selectedState === 'Other'">
                      {{
                        $t('Other state uyarı text', {
                          price: additionalSetupFeeProduct.currency + additionalSetupFeeProduct.final_price,
                        })
                      }}
                    </li>
                    <li v-if="currentState.toUpperCase() === 'TEKSAS'">{{ $t('Teksas uyarı text') }}</li>
                    <li v-else>{{ $t('Eyalet uyarı text5', { state: currentState }) }}</li>
                  </ul>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import RegisterStore from '../../../stores/register';
import CompanyStore from '../../../stores/company';
import TokenStore from '@/stores/token';
import InputField from './../../InputField.vue';
import globalActivityAreasHelper from '../../../assets/helpers/globalActivityAreasHelper';

export default {
  components: {
    InputField,
  },
  props: {
    usProducts: {
      type: Array,
      default: () => {
        return [];
      },
    },
    states: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      isCompanyTitle: true,
      types: [],
      selectedCompanyType: {},
      title: '',
      company: {
        global_activity_area: null,
      },
      activityAreaOptions: this.$t('globalActivityAreaOptions'),
      selected_activity_areas: [],
      selected_activity_areas_mock: null,
      selectedState: null,
      otherStateOptions: [
        { key: 'Florida', value: 'Florida' },
        { key: 'Teksas', value: 'Texas' },
      ],
      otherState: null,
      entityTypes: [],
      additionalSetupFeeProduct: {},
      stateFeeProduct: {
        prices: {
          data: [],
        },
      },
      franchiseTaxProduct: {
        prices: {
          data: [],
        },
      },
      expressProduct: {
        prices: {
          data: [],
        },
      },
    };
  },
  created() {
    this.createTestFunctions();
    this.additionalSetupFeeProduct = this.usProducts.find((s) => s.code === 'OTHERSTATEADDITIONALSETUPFEE');

    CompanyStore.dispatch('getTypes', {
      company_nation_id: 2,
    }).then((s) => {
      this.types = s.data.data;
      this.endWaiting();
      if (this.$route.query.companyId !== 'newuser') {
        CompanyStore.dispatch('getCompany').then((s) => {
          if (s.data.data.length) {
            this.company = s.data.data[0];
            if (this.types && this.types.length && this.company.companyType.data) {
              const isSelectedCompanyInTypes = this.types.find((x) => x.id === this.company.companyType.data.id);
              if (isSelectedCompanyInTypes) {
                this.selectedCompanyType = this.company.companyType.data;
              }
            }

            this.title = this.selectedCompanyType.has_title ? this.company.name : this.company.users.data[0].fullname;
            let stateFindData, otherStateFindData;
            if (this.company.state) {
              stateFindData = this.states.find((x) => x.key.toUpperCase() === this.company.state.toUpperCase());

              otherStateFindData = this.otherStateOptions.find(
                (x) => x.key.toUpperCase() === this.company.state.toUpperCase()
              );

              if (!stateFindData && !otherStateFindData) {
                this.company.state = null;
              }
            }

            if (this.company.global_activity_area) {
              this.selected_activity_areas = this.company.global_activity_area.split(',');
              for (let i = 0; i < this.selected_activity_areas.length; i++) {
                const area = this.selected_activity_areas[i];
                const translatedArea = this.getActivityAreaInEnglish(area);

                if (translatedArea !== null) {
                  this.selected_activity_areas[i] = translatedArea;
                } else {
                  this.selected_activity_areas.splice(i, 1);
                  i--;
                }
              }
            }

            if (this.selectedCompanyType) {
              this.getEntityTypes(this.selectedCompanyType.code);
            }
            this.takeItemTopOfTheList(this.states, 'Wyoming');
            this.otherVariable = this.states.find((w) => w.key === 'Other');
            this.otherVariable.value = this.$t('Diğer');
            if (this.company.state) {
              if (stateFindData) {
                this.selectedState = stateFindData.key;
              } else {
                this.selectedState = 'Other';
                this.otherState = otherStateFindData.key;
              }
            }
          }
        });
      }
    });
  },
  watch: {
    selectedStateAndselectedCompanyTypeId: function (val) {
      if ((this.selectedState || this.otherState) && this.selectedCompanyType.id) {
        const uppercaseState =
          this.selectedState !== 'Other'
            ? this.selectedState.toUpperCase()
            : this.otherState
            ? this.otherState.toUpperCase()
            : undefined;

        const selectedStateProducts = this.usProducts.filter(function (item) {
          if (item.code.includes(uppercaseState)) {
            return true;
          }
          return false;
        });

        if (selectedStateProducts.length) {
          const stateFee = selectedStateProducts.find((x) => x.code.includes('USSTATEFEE'));
          if (stateFee) {
            stateFee.final_price = this.getPrice(stateFee.prices.data);
            this.stateFeeProduct = stateFee;
          }

          const franchiseTax = selectedStateProducts.find((x) => x.code.includes('FRANCHISETAX'));
          if (franchiseTax) {
            franchiseTax.final_price = this.getPrice(franchiseTax.prices.data);
            this.franchiseTaxProduct = franchiseTax;
          }

          const expressProduct = selectedStateProducts.find((x) => x.code.includes('USEXPRESSFORMATION'));
          if (expressProduct) {
            expressProduct.final_price = this.getPrice(expressProduct.prices.data);
            this.expressProduct = expressProduct;
          } else {
            this.expressProduct = null;
          }
        }
      }
    },
    'selectedCompanyType.id': function () {
      this.additionalSetupFeeProduct.final_price = this.getPrice(this.additionalSetupFeeProduct.prices.data);
    },
  },
  computed: {
    currentState() {
      return this.selectedState !== 'Other' ? this.selectedState : this.otherState;
    },
    selectedStateAndselectedCompanyTypeId() {
      return `${this.selectedState}|${this.selectedCompanyType.id}|${this.otherState}|`;
    },
  },
  methods: {
    getPrice(prices) {
      if (this.selectedCompanyType.id && prices) {
        const companyTypePrice = prices.find((x) => x.company_type_id === this.selectedCompanyType.id);
        let price;
        if (companyTypePrice) {
          price = companyTypePrice.price;
        }
        return price;
      }
    },
    getEntityTypes(type) {
      $axios.get('entity-types', { params: { company_type: type } }).then((s) => {
        this.entityTypes = s.data;
      });
    },
    sendForm(callback) {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          const selectedProduct = this.types.find((x) => x.id === this.selectedCompanyType.id);
          if (!selectedProduct) {
            this.$toasted.error(this.$t('AlertMessages.Lütfen Firma tipi seçiniz'));
            return;
          }

          if (this.$route.query.companyId === 'newuser') {
            this.startWaiting();
            await RegisterStore.dispatch('createCompany', {
              company_nation_id: 2,
            })
              .then((s) => {
                const token = s.data.token;
                TokenStore.commit('setOnlyAccessToken', token);
                const query = Object.assign({}, this.$route.query);
                delete query.companyId;
                this.$router.replace({ path: this.$route.path, query: query });
              })
              .finally((s) => {
                this.endWaiting();
              });
          }

          let data = {
            company_type_id: this.selectedCompanyType.id,
            company_type_code: this.selectedCompanyType.code,
            name: this.selectedCompanyType.has_title
              ? this.title
              : this.company.users
              ? this.company.users.data[0].fullname
              : undefined,
            register_type: 'register',
            entity_name: this.company.entity_name,
          };
          this.company.global_activity_area = this.selected_activity_areas.join(',');
          if (this.company.global_activity_area != null) {
            data = { ...data, ...{ global_activity_area: this.company.global_activity_area } };
          }
          if (this.selectedState) {
            if (this.selectedState !== 'Other') {
              data.state = this.selectedState;
            } else {
              data.state = this.otherState;
            }
          }
          this.startWaiting();
          RegisterStore.dispatch('step1', data)
            .then((s) => {
              if (this.company.company_nation_id !== 2) {
                this.$store.commit('setremovePackageData', true);
              } else {
                this.$store.commit('setremovePackageData', false);
              }
              if (s.data.success === false) {
                this.$toasted.error(this.$t('AlertMessages.Lütfen Firma tipi seçiniz'));
                this.endWaiting();
                return;
              }
              this.$store.commit('setCompanyId', s.data.data.id);
              callback();
            })
            .catch((e) => {
              this.endWaiting();
            });
        }
      });
    },
    createTestFunctions() {
      this.selectState();
      this.selectEntity();
    },
    getActivityAreaInEnglish(area) {
      if (area && globalActivityAreasHelper[area]) {
        return globalActivityAreasHelper[area];
      }
      return null;
    },
    getAreaValueInLocalLang(area) {
      const matchingOption = this.activityAreaOptions.find((option) => option.value === area);
      return matchingOption.label;
    },
    addToSelectedActivityAreas(e) {
      if (!this.selected_activity_areas.some((item) => item === e) && e) {
        this.selected_activity_areas.push(e);
      }
      this.selected_activity_areas_mock = null;
    },
    removeSelectedArea(index) {
      this.selected_activity_areas.splice(index, 1);
    },
    takeItemTopOfTheList(array, key) {
      const itemIndex = array.findIndex((item) => item.key === key);
      if (itemIndex !== -1) {
        const item = array.splice(itemIndex, 1)[0];
        array.unshift(item);
      }
    },
  },
};
</script>
<style scoped>
.warning-list-field {
  list-style-type: square;
  list-style-position: inside;
  margin-top: 4px;
  margin-left: 0.75rem;
  margin-bottom: 4px;
}
.selected-activity-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}
.selected-activities {
  display: flex;
  align-items: center;
  border: 1px solid #dee2e6;
  padding: 10px 8px !important;
  gap: 10px;
  align-self: stretch !important;
}

.selected-activities .btn {
  padding: 0 !important;
}

.activity-area-warning {
  margin-top: 10px;
  color: black;
}

.activity-area-warning .fa-info-circle {
  margin-right: 8px;
}
.badge-recommended {
  display: inline-flex;
  padding: 2px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 41px;
  border: 1px solid #00aa6b;
  background: rgba(60, 199, 134, 0.16);
  color: #00aa6b;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 166.667% */
  letter-spacing: -0.12px;
}

@media screen and (max-width: 576px) {
  .badge-recommended {
    padding: 1px 6px;
    font-size: 10px;
    font-weight: 400;
  }
}
</style>
